<template>
  <div class="mobile-admin-layout">
    <div class="mobile-content">
      <router-view />
    </div>

    <van-tabbar route safe-area-inset-bottom>
      <van-tabbar-item replace to="/m/admin/student" icon="friends-o">
        学员
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/admin/learning-analysis" icon="chart-trending-o">
        学情
      </van-tabbar-item>
      <van-tabbar-item replace to="/m/admin/me" icon="user-o">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'MobileAdminLayout',

  // 💥 关键新增：组件创建时执行清除
  created() {
    // 确保只要进入手机端，必定清除可能残留的横屏样式
    document.documentElement.classList.remove('landscape-mode');
  }
}
</script>

<style scoped>
.mobile-admin-layout {
  min-height: 100vh;
  background: #f5f7fa;
}

.mobile-content {
  min-height: 100vh;
  padding-bottom: 56px;
  box-sizing: border-box;
}
</style>